<template>
  <div>
    Clan
  </div>
</template>

<script>
export default {
  name: 'AccountSettingsClan',
};
</script>
